/*
 * @描叙: 数据字典 
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-07-25 14:34:03 
*/

import fileConfig from '@/config/fileConfig.js'

export default {
    basePlan: [
        {
            icon: fileConfig.text,
            type: 'WB',
            name: '文本',
            id: '1',
            isDarg: true,
            
        },
        {
            icon: fileConfig.number,
            type: 'NB',
            name: '数字',
            id: '2',
            isDarg: true,
        },
        {
            icon: fileConfig.button,
            type: 'BUTTON',
            name: '按钮',
            id: '3',
            isDarg: true,
        },
        {
            icon: fileConfig.reddot,
            type: 'WARN',
            name: '故障',
            id: '18',
            width: 50,
            height: 50,
            isDarg: true,
        },
    ],
    devciePlan: [
        {
            icon: fileConfig.l_zuji_off,
            type: 'ZJ_1',
            name: '主机',
            id: '4',
            isDarg: true,
            width: 170,
            height: 101,
        },
        {
            icon: fileConfig.n_zuji_off,
            type: 'ZJ_2',
            name: '主机',
            id: '5',
            isDarg: true,
            width: 170,
            height: 90,
        },
        {
            icon: fileConfig.lengqueta_off,
            type: 'LQT',
            name: '冷却塔',
            id: '6',
            isDarg: true,
            width: 90,
            height: 130,
        },
        {
            icon: fileConfig.lengquefa_off,
            type: 'LQF',
            name: '冷却阀',
            id: '7',
            isDarg: true,
            width: 60,
            height: 57,
        },
        {
            icon: fileConfig.shuibeng1_off,
            type: 'SB_1',
            name: '水泵',
            id: '8',
            isDarg: true,
            width: 80,
            height: 67,
        },
        {
            icon: fileConfig.shuibeng2_off,
            type: 'SB_2',
            name: '水泵',
            id: '9',
            isDarg: true,
            width: 80,
            height: 67,
        },
        {
            icon: fileConfig.jishuiqi,
            type: 'JSQ',
            name: '集水器',
            id: '17',
            width: 60,
            height: 57,
            isDarg: true,
        },
    ],
    pipePlan: [
        {
            icon: fileConfig.gd_horizontal_pipe,
            type: 'GD_H',
            name: '',
            id: '10',
            width: 100,
            height: 10,
            isDarg: true,
        },
        {
            icon: fileConfig.gd_vertical_pipe,
            type: 'GD_V',
            name: '',
            id: '11',
            width: 10,
            height: 100,
            isDarg: true,
        },
        {
            icon: fileConfig.gd_left_bottom,
            type: 'GD_Z',
            name: '',
            id: '12',
            width: 25,
            height: 25,
            isDarg: true,
        },
        {
            icon: fileConfig.gd_right_bottom,
            type: 'GD_Z',
            name: '',
            id: '13',
            width: 25,
            height: 25,
            isDarg: true,
        },
        {
            icon: fileConfig.gd_right_top,
            type: 'GD_Z',
            name: '',
            id: '14',
            width: 25,
            height: 25,
            isDarg: true,
        },
        {
            icon: fileConfig.gd_left_top,
            type: 'GD_Z',
            name: '',
            id: '15',
            width: 25,
            height: 25,
            isDarg: true,
        },
        {
            icon: fileConfig.flow_v,
            type: 'LINE_H',
            name: '水流',
            id: '16',
            width: 25,
            height: 25,
            isDarg: true,
        },
        {
            icon: fileConfig.flow_h,
            type: 'LINE_V',
            name: '水流',
            id: '17',
            width: 25,
            height: 25,
            isDarg: true,
        },
        {
            icon: '',
            type: 'LINE_D',
            name: '线条',
            id: '19',
            width: 25,
            height: 25,
            isDarg: true,
        },
        
    ],
}